import type { ChildFieldsErrors, ChildFieldsValues } from './ChildProfileFields';

/**
 * Default empty values for the 9-field child-profile form-block.
 * `'cp'` (child profile) is the existing onboarding ID prefix; A-09
 * keeps it for selector continuity unless the route needs a unique
 * scope.
 *
 * Lives in this `.ts` file (separate from `ChildProfileFields.tsx`)
 * so the component file stays component-only and satisfies
 * react-refresh/only-export-components.
 */
export const DEFAULT_CHILD_FIELDS_VALUES: ChildFieldsValues = {
  childName: '',
  nickname: '',
  birthdate: '',
  gender: '',
  kuscheltier: '',
  interests: '',
  bezugspersonen: '',
  orte: '',
  sonstiges: '',
};

export const DEFAULT_CHILD_FIELDS_ERRORS: ChildFieldsErrors = {
  childName: null,
  birthdate: null,
  gender: null,
};
